import LegalPageLayout from "@/components/feature/LegalPageLayout";
import LegalNoticeSections from "./components/LegalNoticeSections";
import Seo from "@/components/feature/Seo";
import { seoMeta } from "@/lib/seo";

export default function LegalNotice() {
  return (
    <>
      <Seo title={seoMeta.legalNotice.title} description={seoMeta.legalNotice.description} />
      <LegalPageLayout
        kicker="LEGAL NOTICE"
        title="特定商取引法に基づく表記"
        meta="制定日:2026年8月1日"
      >
        <LegalNoticeSections />
      </LegalPageLayout>
    </>
  );
}